import React from "react";
import { useTranslation } from "react-i18next";

import { Button, Label, Title, TitleH1 } from "components/generic";
import { RoleUser } from "../../interfaces/interfaces";

import {
  ContainerValue,
  ContainerLogin,
  ContainerRedirect
} from "components/containers";
import { InputLabel, InputLabelPassword, useInput } from "components/Input";

import { useContextHospi } from "context/ContextHospi";
import {
  EMPTY,
  HOST_PROFILE_VIEW_ROUTE,
  STUDENT_PROFILE_VIEW_ROUTE
} from "utils/constants";
import { ContainerView } from "components/containers";
import { MainSide } from "../ProfileUserEdit/styles";
import { theme } from "styles/theme";
import { useHospiNavigate } from "../../utils/common";

// Max width Container
const maxWidthContainer = "600px";

export const ChangePassword: React.FC = () => {
  const navigate = useHospiNavigate();
  const [loginWrong, setLoginWrong] = React.useState(EMPTY);
  const [changedPassword, setChangedPassword] = React.useState(false);

  const { cognitoUser, changePassword } = useContextHospi();
  const user: RoleUser = cognitoUser?.role || "student";
  const { t } = useTranslation(user);
  const { t: t_login } = useTranslation("login");
  const email_show = useInput(cognitoUser?.email ?? "");
  const password_old = useInput("");
  const password_new = useInput("");
  const password_confirm = useInput("");

  const sendFromData = async () => {
    if (password_new.value !== password_confirm.value) {
      setLoginWrong(t_login("error.unequalPasswords"));
    } else {
      changePassword(String(password_old.value), String(password_new.value))
        .then(() => setChangedPassword((prev) => !prev))
        .catch((err) => {
          // console.log(err.message);
          setLoginWrong(err.message);
        });
    }
  };

  const cancel = async () => {
    navigate(
      user === "host" ? HOST_PROFILE_VIEW_ROUTE : STUDENT_PROFILE_VIEW_ROUTE
    );
  };

  // When changed password
  if (changedPassword)
    return (
      <ContainerLogin>
        <ContainerRedirect>
          <Title m="0 0 24px 0">{t_login("edit.message.title")}</Title>
          <Label lineHeight="150%">{t_login("edit.message.text")}</Label>
        </ContainerRedirect>
        <Button
          main
          fontWeight="400"
          w="100%"
          m="24px 0 0 0"
          onClick={() => {
            setChangedPassword((prev) => !prev);
            navigate(
              user === "host"
                ? HOST_PROFILE_VIEW_ROUTE
                : STUDENT_PROFILE_VIEW_ROUTE
            );
          }}
        >
          OK
        </Button>
      </ContainerLogin>
    );

  return (
    <ContainerView>
      <MainSide>
        <TitleH1 style={{ width: "100%", maxWidth: maxWidthContainer }}>
          {t_login("edit.title")}
        </TitleH1>
        <ContainerValue maxWidth={maxWidthContainer}>
          <Title m="0 0 24px 0" fontSize="20px">
            {t(`${user}Profile.login.title`)}
          </Title>
          <InputLabel
            {...email_show}
            title={t_login("login.email")}
            type="email"
            disabled
          />
          <InputLabelPassword
            {...password_old}
            title={t_login("login.password")}
            type="password"
            placeholder={t_login("edit.currentPassword")}
            p="24px 0"
          />
          <InputLabelPassword
            {...password_new}
            title={t_login("edit.newPassword")}
            type="password"
            placeholder={t_login("edit.newPassword")}
            p="24px 0"
          />
          <InputLabelPassword
            {...password_confirm}
            title={t_login("edit.confirmPassword")}
            type="password"
            placeholder={t_login("edit.newPassword")}
            p="24px 0"
          />
          <Label
            p="0"
            fontColor={loginWrong === EMPTY ? theme.colors.place : "red"}
            fontWeight="400"
          >
            {loginWrong}
          </Label>
        </ContainerValue>

        <div
          style={{ width: "100%", maxWidth: maxWidthContainer }}
          className="buttonGroup"
        >
          <Button normal onClick={cancel} m="0 24px 0 0">
            {t(`${user}Profile.buttonCancel.title`)}
          </Button>
          <Button main onClick={sendFromData}>
            {t(`${user}Profile.buttonSave.title`)}
          </Button>
        </div>
      </MainSide>
    </ContainerView>
  );
};
